export default {
  legals: [],
  latestLegal: {},
};
